var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgShortenHorizontal = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#shorten-horizontal_svg__a)",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.967 15.312v-4.225M6.018 13.037l1.95-1.95 1.95 1.95M7.967.688v4.224M6.018 2.962l1.95 1.95 1.95-1.95M14.663 7.967c0 .715-.585 1.3-1.3 1.3H2.638c-.715 0-1.3-.585-1.3-1.3 0-.715.585-1.3 1.3-1.3h10.725c.715 0 1.3.585 1.3 1.3Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "shorten-horizontal_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));

const ForwardRef = /*#__PURE__*/forwardRef(SvgShortenHorizontal);
export default ForwardRef;